// @flow

import styled, { css } from 'styled-components';

export default styled.button.attrs({
  route: (props : any) => props.route,
})`
  display: inline-block;
  height: 7rem;
  font-size: 1rem;
  margin: 1.4rem 1rem;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  outline: none;
  border: none;
  position: relative;
  border-radius: .3rem;
  ${(props : any) => (css`
    width: ${props.size}rem; 
  `)}
  background: #292a33;
  /* &:before {
    content: "";
    background-image: url("${(props : any) => props.bgImage}");
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
    z-index: 0;
    opacity: .25;
  } */
  &:first-child {
    margin-right: 0;
  }
  &.activeItem {
    background: #ea1d5d !important;
    > .categoryTitle {
      color: #f5f5f9;
    }
  }
  &:hover {
    background: #484b62;
  }
  > .categoryTitle {
    color: #d3d6e0;
    margin: 0;
    padding: 0;
    font-size: 1.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }
`;
